'use client';

import { Navigate } from 'react-router-dom';
import { useContextOrg } from '@/hooks/use-context-org';

/** Legacy entry point for branding, now a section of the unified CER detail. */
export default function PersonalizzazioneRedirect() {
	const contextOrg = useContextOrg();
	if (!contextOrg) return null;
	return <Navigate to={`/cer/orgs/${contextOrg.cerId}/details`} replace />;
}
